import { IGlobalState } from '../../../Root/store/appReducer'

export const getImportUsersUploading = (state: IGlobalState) => state.importUsersAdmin?.uploading
export const getImportUsersResult = (state: IGlobalState) => state.importUsersAdmin?.result
